import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Dialog from 'components/ReusableComponents/Dialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useEffect, useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import hotelSetupApi from 'services/api/hotelSetup'

import styles from './CheckACHStatus.module.scss'

const CheckACHStatus = () => {
  const { addToast } = useToasts()

  const [isErred, setIsErred] = useState(false)
  const [isSuccesful, setIsSuccesful] = useState(false)

  const [errorText, setErrorText] = useState()

  useEffect(() => {
    hotelSetupApi
      .checkAchAuthForm()
      .then(() => {
        addToast('ACH payment was succesful', {
          appearance: 'success'
        })
        setIsSuccesful(true)
      })
      .catch(err => {
        if (err.message.includes('Setup is not completed yet')) {
          setErrorText('Setup is not completed yet.')
        } else if (err.message.includes('Payment fail')) {
          setErrorText('ACH payment was not succesful.')
        } else if (err.message.includes('ACH contract is not signed')) {
          setErrorText('ACH contract is not signed.')
        } else if (err.message.includes('ACH contract data is corrupted')) {
          setErrorText('ACH contract data is corrupted.')
        } else {
          setErrorText('Something went wrong.')
        }

        setIsErred(true)
      })
  }, [addToast])

  if (isErred) {
    return (
      <ConfirmationDialog
        title="Your payment was not successful"
        positiveMessage="Go back to payment"
        hasCloseButton={false}
        confirmLink="/hotel-setup/"
      >
        <p>
          {errorText} If you think this is a mistake, please contact us at{' '}
          <a target="_blank" href="mailto:billing@directful.com" rel="noreferrer">
            billing@directful.com
          </a>
          .
        </p>
      </ConfirmationDialog>
    )
  }

  if (isSuccesful) {
    return (
      <ConfirmationDialog
        title="Your payment was successful"
        positiveMessage="Start using the Directful Dashboard"
        hasCloseButton={false}
        onConfirm={() => {
          window.location.reload()
        }}
      >
        <p>Thank you for your payment. Hotel setup is now complete.</p>
      </ConfirmationDialog>
    )
  }

  return (
    <Dialog>
      <div className={styles.container}>
        <LoadingIndicator inline longWaitingTreshold={999} />
        <p className={styles.text}>Please wait while we confirm your ACH details.</p>
      </div>
    </Dialog>
  )
}

export default CheckACHStatus
